import React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import __ from "src/utils/Translations";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import ImportListing from "src/Pages/Company/TotalReward/ImportExport/Import/table";
import ExportForm from "src/Pages/Company/TotalReward/ImportExport/Export/form";

export default () => {
  const companyName = useCompanyName();
  const companyId = useCompanyId();

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      <PageTitle
        heading={`${__(
          "Import/export benefitów dla firmy"
        )} ${companyName} (ID: ${companyId})`}
        breadcrumbsHeading={__("Import/export benefitów")}
        pushToHistory
        breadcrumbs={[
          {
            title: "Total Reward Statement",
            link: `/ahr/total-reward`,
          },
        ]}
      />
      <ExportForm companyId={companyId} />
      <ImportListing companyId={companyId} />
    </CSSTransitionGroup>
  );
};
